"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Animation = void 0;

var react_1 = __importStar(require("react"));

var effects_1 = require("./effects/effects");

var components_utils_1 = require("@conte-ltd/components-utils");

var merge_keyframes_1 = require("./merge-keyframes");

var use_animation_1 = require("./use-animation");

function _Animation(props, fwRef) {
  var children = props.children,
      id = props.id,
      playbackRate = props.playbackRate,
      _a = props.autoPlay,
      autoPlay = _a === void 0 ? false : _a,
      keyframes = props.keyframes,
      options = props.options,
      onReady = props.onReady,
      onUpdate = props.onUpdate,
      onFinish = props.onFinish,
      other = __rest(props, ["children", "id", "playbackRate", "autoPlay", "keyframes", "options", "onReady", "onUpdate", "onFinish"]);

  var filteredEffects = Object.entries(other).filter(function (_a) {
    var _b = __read(_a, 2),
        key = _b[0],
        value = _b[1];

    return key in effects_1.effects && value;
  });
  var mergedKeyframes = merge_keyframes_1.mergeKeyframes.apply(void 0, __spreadArray([], __read(filteredEffects.map(function (_a) {
    var _b = __read(_a, 1),
        key = _b[0];

    var keyframes = effects_1.effects[key].keyframes;
    return keyframes;
  })), false));

  var mergedOptions = __assign({}, filteredEffects.reduce(function (prev, _a) {
    var _b = __read(_a, 1),
        key = _b[0];

    var timing = effects_1.effects[key].timing;
    return __assign(__assign(__assign({}, prev), timing), {
      fill: timing.fill
    });
  }, {}));

  var _b = (0, use_animation_1.useAnimation)({
    id: id,
    playbackRate: playbackRate,
    autoPlay: autoPlay,
    keyframes: keyframes !== null && keyframes !== void 0 ? keyframes : mergedKeyframes,
    options: options !== null && options !== void 0 ? options : mergedOptions,
    onReady: onReady,
    onUpdate: onUpdate,
    onFinish: onFinish
  }),
      ref = _b.ref,
      _animate = _b.animate,
      getAnimation = _b.getAnimation,
      _getContext = _b.getContext;

  (0, react_1.useImperativeHandle)(fwRef, function () {
    return {
      play: function play() {
        var animation = getAnimation();
        animation === null || animation === void 0 ? void 0 : animation.play();
      },
      pause: function pause() {
        var animation = getAnimation();
        animation === null || animation === void 0 ? void 0 : animation.pause();
      },
      reverse: function reverse() {
        var animation = getAnimation();
        animation === null || animation === void 0 ? void 0 : animation.reverse();
      },
      cancel: function cancel() {
        var animation = getAnimation();
        animation === null || animation === void 0 ? void 0 : animation.cancel();
      },
      finish: function finish() {
        var animation = getAnimation();
        animation === null || animation === void 0 ? void 0 : animation.finish();
      },
      seek: function seek(value) {
        var animation = getAnimation();

        if (animation === null || animation === void 0 ? void 0 : animation.effect) {
          var time = Number(animation.effect.getTiming().duration) / 100 * value;
          animation.currentTime = time;
        }
      },
      animate: function animate(props, context) {
        _animate(props, context);
      },
      getId: function getId() {
        var _a;

        var animation = getAnimation();
        return (_a = animation === null || animation === void 0 ? void 0 : animation.id) !== null && _a !== void 0 ? _a : '';
      },
      getPlayState: function getPlayState() {
        var _a;

        var animation = getAnimation();
        return (_a = animation === null || animation === void 0 ? void 0 : animation.playState) !== null && _a !== void 0 ? _a : 'idle';
      },
      getContext: function getContext() {
        return _getContext();
      },
      updatePlaybackRate: function updatePlaybackRate(rate) {
        var animation = getAnimation();
        animation === null || animation === void 0 ? void 0 : animation.updatePlaybackRate(rate);
      }
    };
  });
  return react_1.default.createElement(react_1.default.Fragment, null, (0, components_utils_1.useRunIfFunction)(children, {
    ref: ref
  }));
}

exports.Animation = (0, react_1.forwardRef)(_Animation);